import { createApi } from '@reduxjs/toolkit/query/react'
import { backendBaseQuery } from '@shared/api'

export const authExistsApi = createApi({
  reducerPath: 'auth-user-exist',
  baseQuery: backendBaseQuery,
  endpoints: (build) => ({
    userExists: build.query<Boolean, string>({
      query: (userPlatformId) => ({
        url: `auth/exists/${userPlatformId}`, 
        method: 'GET'
      })
    }),
  }),
})

export const { useUserExistsQuery } = authExistsApi